import React from "react";

const UploadPicture = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M29.636 20.6V25H34v2.933h-4.364v4.4h-2.909v-4.4h-4.363V25h4.363v-4.4h2.91zM29.648 3a1.45 1.45 0 011.443 1.456v13.712a8.646 8.646 0 00-2.91-.501V5.933H4.91l.002 20.534 13.515-13.63a1.447 1.447 0 011.92-.123l.136.124 5.157 5.207a8.71 8.71 0 00-3.076 1.685 8.793 8.793 0 00-2.173 2.768 8.86 8.86 0 00-.438 6.903L3.442 29.4c-.382 0-.749-.154-1.02-.427A1.463 1.463 0 012 27.943V4.457c.003-.385.155-.753.425-1.026.27-.272.636-.427 1.018-.43h26.205zm-18.92 5.867c.77 0 1.51.309 2.056.859s.852 1.296.852 2.074c0 .778-.306 1.524-.852 2.074-.545.55-1.285.86-2.057.86a2.897 2.897 0 01-2.057-.86 2.946 2.946 0 01-.852-2.074c0-.778.307-1.524.852-2.074a2.897 2.897 0 012.057-.86z"
          fill={fill}
      />
    </svg>
);

export default UploadPicture;